import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const digitalGuardian = defineConnector({
  identifier: "digitalGuardian",
  name: "Digital Guardian",
  tagLine: "Data loss prevention",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) => urlToPattern(baseUrl),
  auth: oauthAuth,
  steps: [
    {
      title: "Collect your ARC API details",
      items: [
        {
          kind: "markdown",
          content:
            "In the Digital Guardian Management Console, go to **System > Configuration > Cloud Services**. From the **API Access** section copy the **API Access ID**, **API Access Secret**, **Access Gateway Base URL**, and **Authorization Server URL**. You'll also need the **Export Profile GUID** of an export profile to read from.",
        },
      ],
    },
    {
      title: "Enter your ARC API details",
      items: [
        {
          kind: "url",
          label: "Access gateway base URL",
          placeholder: "https://accessgw-usw.msp.digitalguardian.com",
          required: true,
          helperText: "The ARC gateway host that serves the export API.",
          target: { kind: "configuration", field: "baseUrl" },
        },
        {
          kind: "url",
          label: "Authorization server URL",
          placeholder:
            "https://authsrv.msp.digitalguardian.com/as/token.oauth2",
          required: true,
          helperText: "The full token URL, including the path.",
          target: { kind: "configuration", field: "authServerUrl" },
        },
        {
          kind: "input",
          label: "Export profile GUID",
          required: true,
          helperText: "Used to verify the connection.",
          target: { kind: "configuration", field: "exportProfileId" },
        },
        {
          kind: "input",
          label: "API access ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "API access secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    clientCredentialsFrom: "db",
    tokenEndpoint: (cfg) => cfg.authServerUrl ?? "",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => ["client"],
  },
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl, exportProfileId }) => ({
      url: `${baseUrl}/rest/1.0/export/${exportProfileId}`,
      expectedStatus: [200, 204],
    }),
  },
});
